import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "chat-overlay"
}
const _hoisted_2 = {
  key: 0,
  class: "modal fade show",
  tabindex: "-1",
  role: "dialog",
  style: {"display":"block"}
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-footer" }
const _hoisted_6 = {
  key: 0,
  class: "alert-message no-user-alert"
}
const _hoisted_7 = {
  key: 0,
  class: "alert-message websocket-alert"
}
const _hoisted_8 = {
  key: 0,
  class: "alert-message websocket-alert"
}
const _hoisted_9 = { class: "overlay-container" }
const _hoisted_10 = { class: "overlay-chat-window d-flex" }
const _hoisted_11 = { class: "sidebar-header" }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between w-100" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "user-count me-2" }
const _hoisted_15 = { class: "user-list" }
const _hoisted_16 = { class: "user-name" }
const _hoisted_17 = { class: "chat-main" }
const _hoisted_18 = { class: "overlay-header d-flex align-items-center justify-content-between" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = {
  key: 0,
  ref: "endWarning",
  class: "end-of-chat-warning"
}
const _hoisted_22 = {
  class: "timer",
  ref: "timer"
}
const _hoisted_23 = {
  class: "overlay-messages",
  ref: "messagesContainer"
}
const _hoisted_24 = {
  key: 0,
  class: "me-2 align-self-start"
}
const _hoisted_25 = {
  key: 1,
  class: "citation-wrapper mb-2"
}
const _hoisted_26 = { class: "citation-content" }
const _hoisted_27 = { class: "citation-header" }
const _hoisted_28 = { class: "citation-author" }
const _hoisted_29 = { class: "citation-text" }
const _hoisted_30 = { class: "message-bubble-wrapper" }
const _hoisted_31 = { class: "message-bubble" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "formatting-toolbar m-2" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = { class: "emoji-picker-wrapper" }
const _hoisted_36 = {
  key: 0,
  class: "emoji-picker-container"
}
const _hoisted_37 = {
  key: 0,
  class: "reply-preview"
}
const _hoisted_38 = { class: "reply-content" }
const _hoisted_39 = { class: "reply-header" }
const _hoisted_40 = { class: "reply-sender" }
const _hoisted_41 = { class: "reply-text" }
const _hoisted_42 = ["v-if"]
const _hoisted_43 = { class: "text-muted" }
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = ["contenteditable"]
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_ctx.showChat)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showCloseConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "modal-header" }, [
                    _createElementVNode("h5", { class: "modal-title" }, "Chat beenden")
                  ], -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-body" }, [
                    _createElementVNode("p", { class: "mb-0" }, "Möchten Sie den Chat wirklich beenden?")
                  ], -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCloseConfirmation(false)))
                    }, " Nein "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-chat",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCloseConfirmation(true)))
                    }, " Ja ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.showNoUsersAlert)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[19] || (_cache[19] = [
                  _createElementVNode("div", { class: "alert alert-warning" }, " Es sind keine anderen Benutzer im Raum. Ihre Nachricht kann nicht gesendet werden. ", -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.webSocketStatus != 'connected')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[20] || (_cache[20] = [
                  _createElementVNode("div", { class: "alert alert-warning" }, [
                    _createTextVNode(" Die Verbindung zum Server ist unterbrochen. Bitte überprüfen Sie ihre Internetverbindung. Sie können keine Nachrichten senden / empfangen. "),
                    _createElementVNode("br")
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.showUpdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[21] || (_cache[21] = [
                  _createElementVNode("div", { class: "alert alert-warning" }, " Der Termin wurde vom Berater verlängert. Bitte schließen Sie den Chat und öffnen Sie ihn erneut. ", -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["user-sidebar", { 'active': _ctx.sidebarActive }])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[23] || (_cache[23] = _createElementVNode("h6", { class: "mb-0" }, "Aktive Benutzer", -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.userList.length), 1),
                    _createElementVNode("button", {
                      class: "hide-sidebar-btn d-md-none",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                    }, _cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1)
                    ]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (user) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: user.username,
                    class: "user-item"
                  }, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", {
                      "aria-hidden": "true",
                      class: "user-icon"
                    }, [
                      _createElementVNode("i", { class: "bi bi-person" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(user.username) + " (" + _toDisplayString(user.userType == "ADVISOR" ? "Berater:in" : "Klient:in ") + ") ", 1)
                  ]))
                }), 128))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["sidebar-backdrop", { 'active': _ctx.sidebarActive }]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
            }, null, 2),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "sidebar-toggle d-md-none",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                  }, _cache[25] || (_cache[25] = [
                    _createElementVNode("i", { class: "bi bi-list" }, null, -1)
                  ])),
                  _cache[26] || (_cache[26] = _createElementVNode("div", {
                    "aria-hidden": "true",
                    class: "header-icon me-2"
                  }, [
                    _createElementVNode("i", {
                      "aria-hidden": "true",
                      class: "bi bi-chat-fill"
                    })
                  ], -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("h5", { class: "mb-0" }, "Onlineberatung Chat", -1))
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "btn-minimize me-2",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.minimizeChat && _ctx.minimizeChat(...args))),
                    title: "Chat minimieren"
                  }, _cache[28] || (_cache[28] = [
                    _createElementVNode("i", { class: "bi bi-dash-lg" }, null, -1)
                  ])),
                  _createElementVNode("button", {
                    class: "btn-close btn-close-white",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.initiateClose && _ctx.initiateClose(...args)))
                  })
                ]),
                (_ctx.endsInFiveMinutes())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _cache[29] || (_cache[29] = _createTextVNode("Hinweis: Der Termin endet bald. ")),
                      _createElementVNode("span", _hoisted_22, "05:00", 512)
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(message.type)
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex w-full mb-4", message.type === 'own-user' ? 'justify-content-end' : 'justify-content-start' ])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["message-container", _ctx.getMessageCssClassForUser(message.sender)])
                      }, [
                        (message.type !== 'system')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("span", null, _toDisplayString(message.sender), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (message.replyTo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _cache[30] || (_cache[30] = _createElementVNode("i", { class: "bi bi-reply-fill me-1" }, null, -1)),
                                  _createElementVNode("span", _hoisted_28, "Antwort an " + _toDisplayString(message.replyTo.sender), 1)
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_29, null, 512), [
                                  [_directive_dompurify_html, message.replyTo.text]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("div", null, null, 512), [
                              [_directive_dompurify_html, message.text]
                            ])
                          ]),
                          (message.type !== 'system')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "reply-button",
                                onClick: ($event: any) => (_ctx.startReply(message, index)),
                                title: "Auf diese Nachricht antworten"
                              }, _cache[31] || (_cache[31] = [
                                _createElementVNode("i", { class: "bi bi-reply" }, null, -1)
                              ]), 8, _hoisted_32))
                            : _createCommentVNode("", true)
                        ])
                      ], 2)
                    ], 2)
                  ], 2))
                }), 128))
              ], 512),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("button", {
                    class: "btn btn-format",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formatText('bold'))),
                    title: "Fett"
                  }, _cache[32] || (_cache[32] = [
                    _createElementVNode("i", { class: "bi bi-type-bold" }, null, -1)
                  ])),
                  _createElementVNode("button", {
                    class: "btn btn-format",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formatText('italic'))),
                    title: "Kursiv"
                  }, _cache[33] || (_cache[33] = [
                    _createElementVNode("i", { class: "bi bi-type-italic" }, null, -1)
                  ])),
                  _createElementVNode("button", {
                    class: "btn btn-format",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formatText('underline'))),
                    title: "Unterstrichen"
                  }, _cache[34] || (_cache[34] = [
                    _createElementVNode("i", { class: "bi bi-type-underline" }, null, -1)
                  ])),
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "vr mx-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      class: "btn btn-format",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleEmojiPicker && _ctx.toggleEmojiPicker(...args))),
                      title: "Emoji einfügen"
                    }, _cache[35] || (_cache[35] = [
                      _createElementVNode("i", { class: "bi bi-emoji-smile" }, null, -1)
                    ])),
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        (_ctx.showEmojiPicker)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createVNode(_component_EmojiPicker, { onSelect: _ctx.handleEmojiSelect }, null, 8, ["onSelect"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              (_ctx.activeReply)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _cache[37] || (_cache[37] = _createElementVNode("i", { class: "bi bi-reply-fill me-2" }, null, -1)),
                        _createElementVNode("span", _hoisted_40, "Antwort an " + _toDisplayString(_ctx.activeReply.sender), 1)
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_41, null, 512), [
                        [_directive_dompurify_html, _ctx.activeReply.text]
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "reply-cancel",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.cancelReply && _ctx.cancelReply(...args)))
                    }, _cache[38] || (_cache[38] = [
                      _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.typingMessage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    "v-if": _ctx.showTypingNotification,
                    class: "typing-indicator"
                  }, [
                    _createElementVNode("small", _hoisted_43, _toDisplayString(_ctx.typingMessage), 1)
                  ], 8, _hoisted_42))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["overlay-input", { 'chat-input-disabled': _ctx.chatInputDisabled }])
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", {
                    id: "input-textfield",
                    tabindex: "0",
                    ref: "messageInput",
                    class: "form-control rich-input",
                    contenteditable: !_ctx.chatInputDisabled,
                    autofocus: "",
                    style: {"padding":"0.25rem 0.5625rem"},
                    onKeydown: [
                      _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
                      _cache[13] || (_cache[13] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]), ["enter"]))
                    ],
                    onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                    onPaste: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)))
                  }, null, 40, _hoisted_45),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-chat send-button",
                    disabled: !_ctx.hasValidMessage || _ctx.chatInputDisabled,
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                  }, _cache[39] || (_cache[39] = [
                    _createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1)
                  ]), 8, _hoisted_46)
                ])
              ], 2)
            ])
          ])
        ])
      ], 512)), [
        [_vShow, !_ctx.minimized]
      ])
    : _createCommentVNode("", true)
}